<app-loading></app-loading>
<router-outlet></router-outlet>
<app-floating-consult *ngIf="showFloating"></app-floating-consult>